/* Judge.me star glyph fix (part 2 of 2).
 *
 * Part 1 (cordiale-base.css) replaces the classic widget's `.jdgm-star::before`
 * icon-font glyphs with SVG masks.
 *
 * This file covers Judge.me's newer Vue components (review photo popup /
 * lightbox), which render the star as a PUA character (U+E000 full, U+E001
 * empty, U+E002 half) as a TEXT NODE inside `.jm-star-rating__font-icon`,
 * still relying on the broken JudgemeStar icon font. CSS cannot tell a full
 * star span from an empty one (same class, only the text differs), so we swap
 * the character for an inline SVG that inherits the component's color.
 */
(function () {
  'use strict';

  var OUTER = 'M12 1.8 L15.1 8.7 L22.3 9.4 L16.9 14.4 L18.5 21.6 L12 17.9 L5.5 21.6 L7.1 14.4 L1.7 9.4 L8.9 8.7 Z';
  var INNER = 'M12 5.68 L13.92 9.95 L18.39 10.39 L15.04 13.49 L16.03 17.95 L12 15.66 L7.97 17.95 L8.96 13.49 L5.61 10.39 L10.08 9.95 Z';
  var SVG_OPEN = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false" style="width:1em;height:1em;display:inline-block;vertical-align:-0.1em;">';

  var SVGS = {};
  SVGS['\ue000'] = SVG_OPEN + '<path d="' + OUTER + '"/></svg>';
  SVGS['\ue001'] = SVG_OPEN + '<path fill-rule="evenodd" d="' + OUTER + ' ' + INNER + '"/></svg>';
  SVGS['\ue002'] = SVG_OPEN + '<defs><clipPath id="jdgm-half-clip"><rect x="0" y="0" width="12" height="24"/></clipPath></defs>' +
    '<path fill-rule="evenodd" d="' + OUTER + ' ' + INNER + '"/>' +
    '<path clip-path="url(#jdgm-half-clip)" d="' + OUTER + '"/></svg>';

  function fix(root) {
    var els = root.querySelectorAll('.jm-star-rating__font-icon');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var ch = (el.textContent || '').trim();
      if (SVGS[ch]) el.innerHTML = SVGS[ch];
    }
  }

  /* setTimeout, not requestAnimationFrame: rAF is paused while the tab is in the
     background, so a page opened in a background tab would never get its stars
     fixed. setTimeout still fires (throttled) either way. */
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      fix(document);
    }, 50);
  }

  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  }
  window.addEventListener('load', schedule);
  fix(document);
  schedule();
})();
